import React from "react";
import LCSWAgreementTermsAndConditions from "./LCSWAgreementTermsAndConditions";
import CaseContractTermsAndConditions from "./CaseContractTermsAndConditions";
import FeedbackStatementTermsAndConditions from "./FeedbackStatementTermsAndConditions";
import Nav from "../components/Nav";
import { Navigate } from "react-router-dom";
import ConsentToRecordTermsAndConditions from "./ConsentToRecordTermsAndConditions";
import sanityClient from "../client";

class TermsAndConditions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullNameWarning:
        "Enter your full name in the following field to digitally sign the agreements",
      formError: null,
      isCaseContractApproved: false,
      isConsentToRecordApproved: false,
      isAgreementLCSWApproved: false,
      isFeedbackStatementApproved: false,
      agreementWarning:
        "Note: You must open each of the following agreements and click the acknowledgement button at the bottom of each agreement to continue.",
      reviewId: "",
      showingForm: true,
      showingCaseContract: false,
      showingLCSWAgreement: false,
      showingFeedbackStatement: false,
      shouldRedirect: false,
      fullName: "",
      signatureAcknowledgement: "",
    };
  }

  componentDidMount() {
    const query = `*[_type == "intakeFormSettings"]`;
    const params = {};
    this.setState({ reviewId: localStorage.getItem("reviewId") });
    sanityClient.fetch(query, params).then((intakeFormSettings) => {
      console.log("intakeFormSettings:");
      intakeFormSettings.forEach((settings) => {
        console.log(`${settings._id} (${settings.originalStatement})`);
        this.setState({ originalStatement: settings.originalStatement });
        this.setState({ formTitle: settings.title });
        this.setState({
          signatureAcknowledgement: settings.signatureAcknowledgement,
        });
      });
    });
  }

  handleChange = (event) => {
    this.setState({ fullName: event.target.value });
  };

  // Submit here is a misnomer. It's a patch to the document.
  submitCaseReview = (event) => {
    event.preventDefault();

    let values = {
      caseContract: false,
      consentToRecord: false,
      agreementLCSW: false,
      feedbackStatement: false,
    };

    values.caseContract = this.state.isCaseContractApproved;
    values.agreementLCSW = this.state.isAgreementLCSWApproved;
    values.feedbackStatement = this.state.isFeedbackStatementApproved;
    values.consentToRecord = this.state.isConsentToRecordApproved;

    console.log("After modification");
    console.log(values);

    if (!values.caseContract) {
      console.log(
        "Case contract was not accepted...returning with user-facing error."
      );
      this.setState({
        formError: "You must accept the case contract to continue",
      });
      return;
    }

    if (!values.agreementLCSW) {
      console.log(
        "LCSW agreement was not accepted...returning with user-facing error."
      );
      this.setState({
        formError: "You must accept the LCSW agreement to continue",
      });
      return;
    }

    if (!values.feedbackStatement) {
      console.log(
        "Feedback statement was not accepted...returning with user-facing error."
      );
      this.setState({
        formError: "You must accept the feedback statement to continue",
      });
      return;
    }

    if (!values.consentToRecord) {
      console.log(
        "Consent to record was not accepted...returning with user-facing error."
      );
      this.setState({
        formError: "You must accept the consent to record to continue",
      });
      return;
    }

    console.log("this.state.fullName");
    console.log(this.state.fullName);
    if (!this.state.fullName) {
      this.setState({
        formError: "You must type your name in the field to continue",
      });
      return;
    }

    if (this.state.fullName && this.state.fullName.length < 4) {
      this.setState({
        formError: "You must type your full name in the field to continue",
      });
      return;
    }

    sanityClient
      .patch(this.state.reviewId)
      .set(values)
      .commit()
      .then((updatedRecord) => {
        console.log("Updated record: ");
        console.log(updatedRecord);
      })
      .catch((err) => {
        console.error("The updated failed: ", err.message);
      });
    this.setState({ shouldRedirect: true });
  };

  clearFormErrors() {
    this.setState({ formError: null });
  }

  handleLCSWApproval = () => {
    console.log("Handling LCSW approval");
    this.setState({
      showingForm: true,
      showingLCSWAgreement: false,
      isAgreementLCSWApproved: true,
    });
    this.scrollToBottom();
    this.clearFormErrors();
  };

  handleCaseContractApproval = () => {
    console.log("Handling case contract approval");
    this.setState({
      showingForm: true,
      showingCaseContract: false,
      isCaseContractApproved: true,
    });
    this.scrollToBottom();
    this.clearFormErrors();
  };

  handleFeedbacStatementApproval = () => {
    console.log("Handling feedback statement approval");
    this.setState({
      showingForm: true,
      showingFeedbackStatement: false,
      isFeedbackStatementApproved: true,
    });
    this.scrollToBottom();
    this.clearFormErrors();
  };

  handleConsentToRecordApproval = () => {
    console.log("Handling consent to record approval");
    this.setState({
      showingForm: true,
      showingConsentToRecord: false,
      isConsentToRecordApproved: true,
    });
    this.scrollToBottom();
    this.clearFormErrors();
  };

  openLCSWAgreement = (event) => {
    event.preventDefault();
    this.scrollToTop();
    this.setState({ showingForm: false, showingLCSWAgreement: true });
  };

  openCaseContract = (event) => {
    event.preventDefault();
    this.scrollToTop();
    this.setState({ showingForm: false, showingCaseContract: true });
  };

  openConsentToRecord = (event) => {
    event.preventDefault();
    this.scrollToTop();
    this.setState({ showingForm: false, showingConsentToRecord: true });
  };

  openFeedbackStatement = (event) => {
    event.preventDefault();
    this.scrollToTop();
    this.setState({ showingForm: false, showingFeedbackStatement: true });
  };

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  renderCheckboxes() {
    return (
      <div className="w-80">
        <div className="mt-4 container">
          <p className="title is-4">{this.state.formTitle}</p>
          <p className="subtitle is-4">Medical Records Upload</p>
          <article className="message is-warning mb-4">
            <div className="message-body">{this.state.agreementWarning}</div>
          </article>
        </div>
        <form onSubmit={this.submitCaseReview}>
          <div className="field">
            <div className="control">
              <label className="label" htmlFor="caseContract">
                <input
                  type="checkbox"
                  name="caseContract"
                  className="checkbox mr-2"
                  disabled
                  required
                  value={this.state.isCaseContractApproved}
                  checked={this.state.isCaseContractApproved}
                />
                By submitting this review, I agree to the
                <a
                  href="#"
                  onClick={this.openCaseContract}
                  className="ml-1 mr-3"
                >
                  case contract agreement
                </a>
              </label>
              {/* <ErrorMessage name="name" render={this.renderError} /> */}
            </div>
          </div>
          <div className="field">
            <div className="control">
              <label className="label" htmlFor="agreementLCSW">
                <input
                  type="checkbox"
                  name="agreementLCSW"
                  className="checkbox mr-2"
                  disabled
                  required
                  value={this.state.isAgreementLCSWApproved}
                  checked={this.state.isAgreementLCSWApproved}
                />
                By submitting this review, I agree to the
                <a
                  href="#"
                  onClick={this.openLCSWAgreement}
                  className="ml-1 mr-3"
                >
                  LCSW agreement
                </a>
              </label>
            </div>
          </div>
          <div className="field">
            <div className="control">
              <label className="label" htmlFor="feedbackStatement">
                <input
                  type="checkbox"
                  name="feedbackStatement"
                  className="checkbox mr-2"
                  disabled
                  required
                  value={this.state.isFeedbackStatementApproved}
                  checked={this.state.isFeedbackStatementApproved}
                />
                By submitting this review, I agree to the
                <a
                  href="#"
                  onClick={this.openFeedbackStatement}
                  className="ml-1 mr-3"
                >
                  feedback statement
                </a>
              </label>
            </div>
          </div>
          <div className="field">
            <div className="control">
              <label className="label" htmlFor="consentToRecord">
                <input
                  type="checkbox"
                  name="consentToRecord"
                  className="checkbox mr-2"
                  disabled
                  required
                  value={this.state.isConsentToRecordApproved}
                  checked={this.state.isConsentToRecordApproved}
                />
                By submitting this review, I agree to the
                <a
                  href="#"
                  onClick={this.openConsentToRecord}
                  className="ml-1 mr-3"
                >
                  consent to record
                </a>
              </label>
            </div>
          </div>
          <div className="field mt-4">
            {/* <label>{this.state.fullNameWarning}</label> */}
            <p className="control">
              <span className="mb-2">
                {this.state.signatureAcknowledgement}
              </span>
              <input
                className="input is-primary"
                type="text"
                placeholder="Your full name"
                name="fullName"
                value={this.state.fullName}
                onChange={this.handleChange}
              ></input>
            </p>
          </div>
          {this.state.formError && this.renderError(this.state.formError)}
          {this.redirectAsNeeded()}
          <button
            className="button is-primary mt-3"
            onClick={this.submitCaseReview}
          >
            Submit case review
          </button>
        </form>
        <Nav isTermsAndConditions="is-underlined has-text-weight-bold"></Nav>
      </div>
    );
  }

  renderError = (message) => (
    <article className="message is-danger">
      <div className="message-body">{message}</div>
    </article>
  );

  redirectAsNeeded() {
    console.log("Redirect as needed...");
    
    // Redirect to checkout page or sponsor page
    if (this.state.shouldRedirect) {
      if (localStorage.getItem("searchParam1") === "sponsored") {
        return <Navigate replace to="/sponsor" />;
      } else {
        return <Navigate replace to="/checkout" />;
      }
    }
  }

  render() {
    return (
      <div>
        {this.state.showingForm && this.renderCheckboxes()}
        {this.state.showingLCSWAgreement && (
          <LCSWAgreementTermsAndConditions
            handleApproval={this.handleLCSWApproval}
          ></LCSWAgreementTermsAndConditions>
        )}
        {this.state.showingCaseContract && (
          <CaseContractTermsAndConditions
            handleApproval={this.handleCaseContractApproval}
          ></CaseContractTermsAndConditions>
        )}
        {this.state.showingFeedbackStatement && (
          <FeedbackStatementTermsAndConditions
            handleApproval={this.handleFeedbacStatementApproval}
          ></FeedbackStatementTermsAndConditions>
        )}
        {this.state.showingConsentToRecord && (
          <ConsentToRecordTermsAndConditions
            handleApproval={this.handleConsentToRecordApproval}
          ></ConsentToRecordTermsAndConditions>
        )}
      </div>
    );
  }
}

export default TermsAndConditions;
